// removed by extract-text-webpack-plugin
module.exports = {"icon-addon":"app-components-Fields-ReduxForm-SettingInteger-__SettingInteger___1SWcG","icon-pos":"app-components-Fields-ReduxForm-SettingInteger-__SettingInteger___2fyn7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Fields/ReduxForm/SettingInteger/SettingInteger.css
// module id = 2191
// module chunks = 0